export default __webpack_public_path__ + "static/media/link.16911cb7.svg";